const StudentsSettingsPage = () => {
  return <div>Hello from StudentPage</div>;
};

export default StudentsSettingsPage;
